/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { MonitEntityAssetTechData } from './MonitEntityAssetTechData';
import {
    MonitEntityAssetTechDataFromJSON,
    MonitEntityAssetTechDataFromJSONTyped,
    MonitEntityAssetTechDataToJSON,
} from './MonitEntityAssetTechData';

/**
 * 
 * @export
 * @interface MonitEntityAssetTechResult
 */
export interface MonitEntityAssetTechResult {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetTechResult
     */
    entity_id?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetTechResult
     */
    entity_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetTechResult
     */
    entity_domain?: string;
    /**
     * 
     * @type {MonitEntityAssetTechData}
     * @memberof MonitEntityAssetTechResult
     */
    data?: MonitEntityAssetTechData;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetTechResult
     */
    asset?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetTechResult
     */
    source_asset?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetTechResult
     */
    port?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetTechResult
     */
    tech_name?: string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof MonitEntityAssetTechResult
     */
    cves?: { [key: string]: any; };
    /**
     * 
     * @type {boolean}
     * @memberof MonitEntityAssetTechResult
     */
    shared?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityAssetTechResult
     */
    found?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityAssetTechResult
     */
    created?: number;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityAssetTechResult
     */
    updated?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityAssetTechResult
     */
    version?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof MonitEntityAssetTechResult
     */
    category?: Array<string>;
}

/**
 * Check if a given object implements the MonitEntityAssetTechResult interface.
 */
export function instanceOfMonitEntityAssetTechResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityAssetTechResultFromJSON(json: any): MonitEntityAssetTechResult {
    return MonitEntityAssetTechResultFromJSONTyped(json, false);
}

export function MonitEntityAssetTechResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityAssetTechResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_id': !exists(json, 'entity_id') ? undefined : json['entity_id'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'data': !exists(json, 'data') ? undefined : MonitEntityAssetTechDataFromJSON(json['data']),
        'asset': !exists(json, 'asset') ? undefined : json['asset'],
        'source_asset': !exists(json, 'source_asset') ? undefined : json['source_asset'],
        'port': !exists(json, 'port') ? undefined : json['port'],
        'tech_name': !exists(json, 'tech_name') ? undefined : json['tech_name'],
        'cves': !exists(json, 'cves') ? undefined : json['cves'],
        'shared': !exists(json, 'shared') ? undefined : json['shared'],
        'found': !exists(json, 'found') ? undefined : json['found'],
        'created': !exists(json, 'created') ? undefined : json['created'],
        'updated': !exists(json, 'updated') ? undefined : json['updated'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'category': !exists(json, 'category') ? undefined : json['category'],
    };
}

export function MonitEntityAssetTechResultToJSON(value?: MonitEntityAssetTechResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_id': value.entity_id,
        'entity_name': value.entity_name,
        'entity_domain': value.entity_domain,
        'data': MonitEntityAssetTechDataToJSON(value.data),
        'asset': value.asset,
        'source_asset': value.source_asset,
        'port': value.port,
        'tech_name': value.tech_name,
        'cves': value.cves,
        'shared': value.shared,
        'found': value.found,
        'created': value.created,
        'updated': value.updated,
        'version': value.version,
        'category': value.category,
    };
}

